import Admin from "./Admin";
import AdminNavbar from "./Admin_Navbar/Admin_Navbar";


export default function AdminDashboard() {
    
  return (
    <>
      <AdminNavbar />

      <Admin />
    </>
  );
}
